<template>
  <div class="mb-4 fullWidth" id="PersonalDetailsCard">
    <v-card-title primary-title>
      <div class="headline mb-0">
        {{ $vuetify.t('$vuetify.order.personalDetails') }}
      </div>
    </v-card-title>

    <v-layout row wrap class="checkout-form">
      <v-flex xs12>
        <v-text-field id="email"
          name="email"
          v-validate="emailIsRequired"
          :data-vv-as="$vuetify.t('$vuetify.common.email').toLowerCase()"
          :error-messages="emailError || errors.collect('email')"
          v-model="email"
          @input="emailError ? validateEmail() : null"
          @blur="validateEmail"
          :label="$vuetify.t('$vuetify.common.email')"
        />
      </v-flex>

      <template v-if="!isDineIn || inFastServiceDineIn">
        <v-flex xs6>
          <v-text-field
            name="first_name"
            v-validate="firstNameIsRequired"
            :data-vv-as="$vuetify.t('$vuetify.common.firstName').toLowerCase()"
            :error-messages="errors.collect('first_name')"
            v-model="firstname"
            :label="$vuetify.t('$vuetify.common.firstName')"
            class="pr-3"
          />
        </v-flex>

        <v-flex xs6>
          <v-text-field
            name="last_name"
            v-validate="nameIsRequired"
            :data-vv-as="$vuetify.t('$vuetify.common.lastName').toLowerCase()"
            :error-messages="errors.collect('last_name')"
            v-model="lastname"
            :label="$vuetify.t('$vuetify.common.lastName')"
          />
        </v-flex>

        <v-flex xs12>
          <v-text-field
            name="phone_number"
            v-validate="!isDineIn ? 'required' : null"
            :data-vv-as="$vuetify.t('$vuetify.common.mobileNumber').toLowerCase()"
            :error-messages="errors.collect('phone_number')"
            v-model="phoneNumber"
            :label="$vuetify.t('$vuetify.common.mobileNumber')"
            mask="phone"
            :disabled="true"
          />
        </v-flex>
      </template>
    </v-layout>
  </div>
</template>

<script>
import get from 'lodash/get';

import { mapMutations, mapGetters } from 'vuex';

import { isNull } from "@/services/util.service"

export default {
  data: () => ({
    emailError: null
  }),

  computed: {
    email: {
      get() {
        return get(this.getCheckoutInfo, 'email', '')
      },
      set(value) {
        this.SET_CHECKOUT_INFO({
          ...this.getCheckoutInfo,
          email: value
        })
      }
    },
    firstname: {
      get() {
        return get(this.getCheckoutInfo, 'firstname', '')
      },
      set(value) {
        this.SET_CHECKOUT_INFO({
          ...this.getCheckoutInfo,
          firstname: value
        })
      }
    },
    lastname: {
      get() {
        return get(this.getCheckoutInfo, 'lastname', '')
      },
      set(value) {
        this.SET_CHECKOUT_INFO({
          ...this.getCheckoutInfo,
          lastname: value
        })
      }
    },
    phoneNumber: {
      get() {
        return get(this.getCheckoutInfo, 'phoneNumber', '')
      },
      set(value) {
        this.SET_CHECKOUT_INFO({
          ...this.getCheckoutInfo,
          phoneNumber: value
        })
      }
    },

    emailIsRequired() {
      return  ((this.getPaymentType[0] === 'online'
        && this.isLoggedIn
        && this.getCheckoutInfo.emailReceipt) ||  this.getRequiredFields('EMAIL')) ? 'required' : null
    },
    firstNameIsRequired() {
      return (this.getRequiredFields('FIRST_NAME') || this.getRequiredFields('NAME')) ? 'required' : null
    },
    nameIsRequired() {
      return this.getRequiredFields('NAME') ? 'required' : null
    },

    ...mapGetters([
      'getCheckoutInfo',
      'getPaymentType',
      'isLoggedIn',
      'isDineIn',
      'inFastServiceDineIn',
      'getStore'
    ])
  },

  methods: {
    isEmailValid(email) {
      if (isNull(email))
        return false

      const re = /\S+@\S+\.\S+/;
      return re.test(email);
    },
    validateEmail() {
      if (!this.emailIsRequired) {
        this.emailError = null;
      } else {
        this.emailError = this.isEmailValid(this.email) 
          ? null 
          : this.$vuetify.t('$vuetify.common.invalidEmail');
      }
    },
    getRequiredFields(requirement) {
      const requiredFields = get(this.getStore, 'settings.orderSettings.requiredCustomerInfomationFields', null)
      return requiredFields && requiredFields.indexOf(requirement) !== -1 && !this.isDineIn
    },

    ...mapMutations([ 'SET_CHECKOUT_INFO' ])
  },

  mounted() {
    this.$bus.$on('validateRun', () => {
      this.validateEmail()
      this.$validator.validateAll();
    })
  },

  watch: {
    '$vuetify.lang.current'() {
      // Need to manually trigger an update when switching languages to update the fields name
      // Unfortunatly this doesn't seem to have a global affect so needs to
      // be included in all pages that use vee-validate
      this.$nextTick(() => {
        this.$validator.validateAll();
      })
    }
  }
}
</script>

<style>
  #PersonalDetailsCard {
    /* border: var(--card-border) !important;
    border-radius: var(--card-border-radius); */
  }

  #PersonalDetailsCard .headline {
    font-size: var(--text-size-2) !important;
  }
</style>
